import * as React from "react";
import { IContentForm } from "./icontent-form";
import { withAuthContext, IAuthContextProps } from "../with-auth-context";
import { FormStateHelperComponent, IDocumentEditModelState, ICreateTags } from "./form-state-helper";
import Typography from "@material-ui/core/Typography/Typography";
import { MediaLinesRequestFactory } from "../../model/autogen/MediaLinesController";
import { ISnackbarContextProps, withSnackbar } from "../with-snackbar";
import DatePicker from "material-ui-pickers/DatePicker";
import { UserLevel } from "../../model/autogen/UserLevel";
import { strIsNullOrEmpty } from "../../utils/string";
import ChevronLeft from "@material-ui/icons/ChevronLeft";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Keyboard from "@material-ui/icons/Keyboard";
import { MediaLinesModel } from "../../model/autogen/MediaLinesModel";
import { WithDefaultStyles, withDefaultStyles } from "../../utils/createStyles";
import { withEditorPage } from "../../pages/editor-page";
import { DATE_DISPLAY_FORMAT } from "../date-display-format";
import * as moment from "moment";
import FormControl from "@material-ui/core/FormControl/FormControl";
import FormLabel from "@material-ui/core/FormLabel/FormLabel";
import Person from "@material-ui/icons/Person";
import Button from "@material-ui/core/Button/Button";
import { PeopleLookupDialog } from "./people-lookup-dialog";
import { IdNamePair } from "../../model/autogen/IdNamePair";
import { isArrayNullOrEmpty } from "utils/array";
import { FilesRequestFactory } from "model/autogen/FilesController";
import { UploadSection } from "./upload-section";

export interface IMediaLinesFormComponentProps extends IContentForm<MediaLinesModel> {

}

export interface IMediaLinesFormComponentState extends MediaLinesModel {
    isUploadingFiles: boolean;
    isPickingPerson: boolean;
}

type MediaLinesFormComponentProps = IMediaLinesFormComponentProps & IAuthContextProps & ISnackbarContextProps & WithDefaultStyles;

export class MediaLinesFormComponent extends React.Component<MediaLinesFormComponentProps, IMediaLinesFormComponentState> {
    constructor(props: MediaLinesFormComponentProps) {
        super(props);
        this.state = { ...props.item, isPickingPerson: false, isUploadingFiles: false };
    }
    private onChange = (key: keyof IMediaLinesFormComponentState, val: any) =>
        this.setState({[key]: val} as any);

    private onDateChanged = (date: moment.Moment) => {
        this.setState({ date: date.toDate() });
    }
    private onPrepareForSave = (localState: IDocumentEditModelState & ICreateTags) => {
        return {
            ...localState,
            ...this.state
        }
    }
    private onPickPerson = (e: any) => {
        this.setState({ isPickingPerson: true });
    }
    private onPersonSelected = (person: IdNamePair) => {
        this.setState({ spokesperson: { ...person }, isPickingPerson: false });
    }
    private onCancelPickingPerson = (e: any) => {
        this.setState({ isPickingPerson: false });
    }
    private onFileDrop = async (acceptedFiles: File[], rejectedFiles: File[]) => {
        const { callApi } = this.props;
        try {
            if (!isArrayNullOrEmpty(acceptedFiles)) {
                this.setState({ isUploadingFiles: true });
                const result = await callApi(f => FilesRequestFactory.upload(f, { file: acceptedFiles[0] }));
                const { assignFiles } = this.state;
                this.setState({ isUploadingFiles: false, assignFiles: [...(assignFiles || []), result] });
            }
        } catch (e) {
            this.props.showSnackbarMessage(`Failed to upload file: ${e}`);
            this.setState({ isUploadingFiles: false });
        }
    }
    public render() {
        const { date, title, createTags, tags, spokesperson, isPickingPerson, isUploadingFiles, assignFiles, files } = this.state;
        const { isEditing, classes, item } = this.props;
        const allTags = [...(createTags || []), ...tags]
        const cannotSave = strIsNullOrEmpty(title) || (date == null) || allTags.length == 0;
        const submitAction = (isEditing === true) 
            ? MediaLinesRequestFactory.update 
            : MediaLinesRequestFactory.create;
        const spokespersonLabel = "Spokesperson";
        return <FormStateHelperComponent
                item={item}
                documentItemTypeName="Media Line Item"
                documentItemTypeNamePlural="Media Line Items"
                documentTypeName="Media Lines"
                initialTags={tags}
                isEditing={this.props.isEditing}
                submitAction={submitAction}
                cannotSave={cannotSave}
                onPrepareForSave={this.onPrepareForSave}
                onSaveCompleted={this.props.onSaveCompleted}
                onChange={this.onChange}
        >{({ DocumentItemListEditor, DocumentTagListEditor, DocumentFormSubmitButton, DocumentTextField }: any) => (
            <div className={classes.root}>
                <Typography className={this.props.classes.input}  variant="h5">{(isEditing === true) ? "Edit" : "New"} Media Lines</Typography>
                <DocumentTextField label="Title" name="title" value={title} extraProps={{ rows: 2, rowsMax: 4 }} />
                <DatePicker format={DATE_DISPLAY_FORMAT} label="Date" autoOk clearable value={date} onChange={this.onDateChanged} leftArrowIcon={<ChevronLeft />} rightArrowIcon={<ChevronRight />} keyboardIcon={<Keyboard />} />
                <FormControl>
                    <FormLabel>{spokespersonLabel}</FormLabel>
                    <p>{spokesperson && <><Person /> {spokesperson.name || `Person with id (${spokesperson.id})`}</>}<Button variant="contained" color="primary" onClick={this.onPickPerson}>Change</Button></p>
                    <PeopleLookupDialog isPickingPerson={isPickingPerson}
                                        personLabel={spokespersonLabel}
                                        onPersonSelected={this.onPersonSelected}
                                        onCancelPickingPerson={this.onCancelPickingPerson} />
                </FormControl>
                <DocumentItemListEditor />
                <DocumentTagListEditor label="Portfolio" />
                <UploadSection onFileDrop={this.onFileDrop} isUploadingFiles={isUploadingFiles} files={files} assignFiles={assignFiles} />
                <DocumentFormSubmitButton />
            </div>
        )}</FormStateHelperComponent>;
    }
}

// HACK: wrapper to workaround the fact that our current codegen doesn't support argument default values, so there's a signature mismatch
const mediaLinesGet = (fetcher: (url: string, init: RequestInit) => Promise<Response>, id: number) => MediaLinesRequestFactory.getById(fetcher, id, false);

const MediaLinesFormComponentWithStyles = withDefaultStyles(MediaLinesFormComponent) as React.ComponentType<MediaLinesFormComponentProps>;

export const MediaLinesForm = withSnackbar(withAuthContext(MediaLinesFormComponentWithStyles, UserLevel.External)) as React.ComponentType<IMediaLinesFormComponentProps>;

export const MediaLinesEditPage = withAuthContext(withEditorPage(MediaLinesForm as any, mediaLinesGet), UserLevel.External) as React.ComponentType<IMediaLinesFormComponentProps>;


// WEBPACK FOOTER //
// ./src/components/forms/media-lines-form.tsx